import {createSlice} from '@reduxjs/toolkit';

import {EChannelType} from 'src/constants';

import {TMessageMatcher, TWhatsAppFormData} from '../definitions';
import {getInitialValues} from '../utils';
import {EOperatorFormStep, TFormStep, TSteps, defaultOperatorSteps} from './definitions';

type TState = {
  activeStep: TFormStep;
  steps: TSteps;
  isDirty?: boolean;
  messageMatcher: TWhatsAppFormData;
  presetMessageMatcher: Partial<TMessageMatcher> | null;
};

const defaultMessageMatcher = getInitialValues(EChannelType.WHATSAPP) as TWhatsAppFormData;

const initialState: TState = {
  activeStep: EOperatorFormStep.DETAILS,
  steps: defaultOperatorSteps,
  messageMatcher: defaultMessageMatcher,
  presetMessageMatcher: null,
};

const whatsAppMessageMatcherSlice = createSlice({
  name: 'whatsAppMessageMatcherSlice',
  initialState,
  reducers: {
    setMessageMatcher(state, {payload}) {
      state.messageMatcher = payload;
    },
    setPresetMessageMatcher(state, {payload}) {
      state.presetMessageMatcher = payload;
    },
    resetMessageMatcher(state) {
      state.messageMatcher = defaultMessageMatcher;
      state.presetMessageMatcher = null;
    },
    setActiveStep(state, {payload}) {
      state.activeStep = payload;
    },
    setSteps(state, {payload}) {
      state.steps = payload;
    },
  },
});

export const {
  setActiveStep: setActiveStepAction,
  setSteps: setStepsAction,
  resetMessageMatcher,
  setMessageMatcher,
  setPresetMessageMatcher,
} = whatsAppMessageMatcherSlice.actions;

export const selectMessageMatcher = (state: TRootState) =>
  state.whatsAppMessageMatcher.messageMatcher;
export const selectPresetMessageMatcher = (state: TRootState) =>
  state.whatsAppMessageMatcher.presetMessageMatcher;
export const selectSteps = (state: TRootState) => state.whatsAppMessageMatcher.steps;
export const selectActiveStep = (state: TRootState) => state.whatsAppMessageMatcher.activeStep;

export default whatsAppMessageMatcherSlice.reducer;
